module.exports = __webpack_public_path__ + "static/images/components/ProductionProgress/images/cancel-button-default.f9542de8.png";


//////////////////
// WEBPACK FOOTER
// ./components/ProductionProgress/images/cancel-button-default.png
// module id = 2659
// module chunks = 11